const CDN = 'https://atrium-template.cdn.modulify.website'

export const media = {
    reelVideo: `${CDN}/media/demeure-reel.mp4`,
    heroVideo: `${CDN}/media/hero-editing-studio.mp4`,
    ogImage: `${CDN}/images/v2/studio/og-image.webp`,
    studioTeam: `${CDN}/images/v3/about-hero.png`,
    studioArches: `${CDN}/images/v2/studio/about-detail-small.webp`,
    studioLounge: `${CDN}/images/v2/studio/about-detail-large.webp`,
    studioRoom: `${CDN}/images/v3/about-office.png`,
    aboutTeamTable: `${CDN}/images/v3/about-team-table.png`,
    aboutStudioDesk: `${CDN}/images/v3/about-studio-desk.png`,
    testimonialTerrace: `${CDN}/images/v3/testimonial-terrace-sunset.png`,
    footerStudio: `${CDN}/images/v3/footer-studio-loft.png`,
    team: {
        marenHolloway: `${CDN}/images/v2/studio/team-maren-holloway.webp`,
        fredericMarchand: `${CDN}/images/v2/studio/team-frederic-marchand.webp`,
        inesCaravallo: `${CDN}/images/v2/studio/team-ines-caravallo.webp`,
        theoKassim: `${CDN}/images/v2/studio/team-theo-kassim.webp`,
        yusukeTanaka: `${CDN}/images/v2/studio/team-yusuke-tanaka.webp`,
        andersNilsson: `${CDN}/images/v2/studio/team-anders-nilsson.webp`
    }
}
